/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Create_Missing_Username_ErrorInputs */

const en_users_create_missing_username_error = /** @type {(inputs: Users_Create_Missing_Username_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created user did not return a username.`)
};

const pt_br2_users_create_missing_username_error = /** @type {(inputs: Users_Create_Missing_Username_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O usuário criado não retornou um identificador.`)
};

/**
* | output |
* | --- |
* | "Created user did not return a username." |
*
* @param {Users_Create_Missing_Username_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_create_missing_username_error = /** @type {((inputs?: Users_Create_Missing_Username_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Create_Missing_Username_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_create_missing_username_error(inputs)
	return pt_br2_users_create_missing_username_error(inputs)
});